<template>
    <div class="content-hearth-intern">
        <div class="content-hearth-intern-itens container">
            <div class="content-brand container">
                <GoToBackButton />
                <div class="content-brand-elements d-none d-lg-block">
                    <router-link tag="a" :to="{ name: 'Home' }" class="content-brand-elements-links">
                        {{ $t('pages.goToBackButton.start') }}
                    </router-link>
                    <span> > </span>
                    <router-link tag="a" :to="{ name: 'Hearth' }" class="content-brand-elements-links">
                        {{ $t('pages.hearth.title') }}
                    </router-link>
                    <span> > </span>
                    <router-link tag="a" :to="{ name: 'HearthIntern' }" class="content-brand-elements-links">
                        {{ hearthIntern.title }}
                    </router-link>
                </div>
                <SocialSharing :title="hearthIntern.title" :description="hearthIntern.description" class="d-lg-none" />
            </div>
            <div class="content-gallery">
                <div class="content-gallery-banner">
                    <!-- swiper1 -->
                    <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
                        <swiper-slide v-for="(img, j) in hearthIntern.images" :key="j">
                            <div class="gallery-top-image" :style="{ backgroundImage: `url('${img}')` }"></div>
                        </swiper-slide>
                        <!-- <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div> -->
                    </swiper>
                    <!-- swiper2 thumbs -->
                    <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
                        <swiper-slide v-for="(n, index) in hearthIntern.images" :key="index">
                            <div class="gallery-thumbs-image" :style="{ backgroundImage: `url('${n}')` }"></div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="content-gallery-description">
                    <div class="content-gallery-description-text container">
                        <h1 class="title">{{ hearthIntern.title }}</h1>
                        <div class="location">
                            <svg xmlns="http://www.w3.org/2000/svg" width="22.489" height="29.985"
                                viewBox="0 0 22.489 29.985">
                                <path
                                    d="M11.244,5.622a5.622,5.622,0,1,0,5.622,5.622A5.628,5.628,0,0,0,11.244,5.622Zm0,9.37a3.748,3.748,0,1,1,3.748-3.748A3.752,3.752,0,0,1,11.244,14.992ZM11.244,0A11.244,11.244,0,0,0,0,11.244c0,4.534,1.579,5.8,10.089,18.135a1.406,1.406,0,0,0,2.311,0c8.509-12.336,10.089-13.6,10.089-18.135A11.244,11.244,0,0,0,11.244,0Zm0,27.755c-8.158-11.8-9.37-12.734-9.37-16.511a9.37,9.37,0,0,1,16-6.626,9.309,9.309,0,0,1,2.744,6.626C20.614,15.021,19.4,15.957,11.244,27.755Z"
                                    fill="#112d23" />
                            </svg>
                            <p>
                                {{ hearthIntern.concelho }},
                                {{ hearthIntern.distrito }}
                            </p>
                        </div>
                    </div>
                    <div class="content-gallery-description-btns container">
                        <div class="content-category-div">
                            <div class="content-category" v-for="(
                                    category, index
                                ) in hearthIntern.category_name" :key="index">
                                <svg xmlns="http://www.w3.org/2000/svg" width="26.213" height="23.301"
                                    viewBox="0 0 26.213 23.301">
                                    <path
                                        d="M25.972,10.753,23.3,8.394V2.184a.728.728,0,0,0-.728-.728H19.66a.728.728,0,0,0-.728.728V4.536L14.325.469A2.093,2.093,0,0,0,13.107,0,2.088,2.088,0,0,0,11.89.469L.239,10.754A.831.831,0,0,0,0,11.3a.848.848,0,0,0,.186.487l.974,1.083a.962.962,0,0,0,.546.241.986.986,0,0,0,.486-.187l.724-.637v9.562A1.456,1.456,0,0,0,4.373,23.3H21.845A1.456,1.456,0,0,0,23.3,21.845V12.282l.724.637a1,1,0,0,0,.488.187.951.951,0,0,0,.54-.242l.974-1.084a.985.985,0,0,0,.186-.486A.956.956,0,0,0,25.972,10.753ZM13.107,8.01a2.913,2.913,0,1,1-2.913,2.913A2.913,2.913,0,0,1,13.107,8.01Zm5.1,12.379H8.01a.728.728,0,0,1-.728-.728,4.369,4.369,0,0,1,4.369-4.369h2.913a4.369,4.369,0,0,1,4.369,4.369A.728.728,0,0,1,18.2,20.388Z"
                                        transform="translate(0)" fill="var( --green-medium)" />
                                </svg>
                                <p>{{ category }}</p>
                            </div>
                        </div>
                        <div class="content-btns">
                            <button class="content-btns-classification" v-scroll-to="'#rate'">
                                <div class="content-btns-classification-note">
                                    <p>{{ hearthIntern.rate }}</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="34.657" height="34.171"
                                        viewBox="0 0 34.657 34.171">
                                        <path
                                            d="M35.969,1.176l-4.23,8.835-9.464,1.421a2.154,2.154,0,0,0-1.147,3.644l6.847,6.873-1.619,9.71a2.085,2.085,0,0,0,3.006,2.249l8.467-4.585,8.467,4.585A2.087,2.087,0,0,0,49.3,31.66l-1.62-9.71,6.847-6.873a2.154,2.154,0,0,0-1.147-3.644l-9.464-1.421-4.23-8.835a2.048,2.048,0,0,0-3.718,0Z"
                                            transform="translate(-20.5 0.013)" fill="#fff" />
                                    </svg>
                                </div>
                                <div class="content-btns-classification-coments">
                                    <p>{{ totalcomment }}</p>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23.552" height="20.645"
                                        viewBox="0 0 23.552 20.645">
                                        <path
                                            d="M11.8,32C5.283,32,0,36.29,0,41.585a8.5,8.5,0,0,0,2.625,6.023A11.731,11.731,0,0,1,.1,52.021a.358.358,0,0,0-.069.4.355.355,0,0,0,.335.221A10.645,10.645,0,0,0,6.85,50.277a14.045,14.045,0,0,0,4.949.894c6.516,0,11.756-4.292,11.756-9.585S18.315,32,11.8,32Z"
                                            transform="translate(-0.002 -32)" fill="#fff" />
                                    </svg>
                                </div>
                            </button>
                            <div class="content-hearth-img-info-btn d-lg-none">
                                <BtnFavorite :name="hearthIntern.title" />
                            </div>
                            <button class="btn-request-contact" v-scroll-to="'#form-request'">
                                {{ $t('pages.hearth.contact') }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="content-hearth-img-info-btn container d-none d-lg-flex">
                    <BtnFavorite :name="hearthIntern.title" />
                    <SocialSharing :title="hearthIntern.title" :description="hearthIntern.description"
                        class="d-none d-lg-flex" />
                </div>
            </div>
            <TextLineClamp :short_description="hearthIntern.description" style="padding: 0 !important" />
            <div class="content-information-general container">
                <div class="row">
                    <div class="col-lg-8 p-0">
                        <div class="content-information-general-text">
                            <div class="content-information-general-text-header">
                                <h2>{{ $t('pages.hearth.information') }}</h2>
                            </div>
                            <div class="content-element-showmore" v-if="showLess">
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">
                                            {{ $t('pages.hearth.entity') }}
                                        </p>
                                        <p class="text">
                                            {{ hearthIntern.partner }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title"> {{ $t('pages.hearth.direction') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.direction }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.address') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.address }},
                                            {{ hearthIntern.number }} <br />
                                            {{ hearthIntern.postal_code }}
                                            {{ hearthIntern.distrito }}
                                        </p>
                                    </div>
                                </div>
                                <div class="btn-general-information d-lg-none">
                                    <button @click="showLess = false">
                                        <p>{{ $t('pages.hearth.more') }}</p>
                                    </button>
                                </div>
                            </div>
                            <div class="content-element-showless desktop">
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.phonecontact') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.telephone }}
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.mail') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.email }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.hourvisit') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.visiting_hours }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.maximumcapacity') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.maximum_capacity }}
                                            {{ $t('pages.hearth.iusers') }}
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title">
                                            {{ $t('pages.hearth.socialsecurity') }}
                                        </p>
                                        <p class="text">
                                            {{ hearthIntern.social_insurance }}
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.datefundation') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.founded }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">
                                            {{ $t('pages.hearth.typeadm') }}
                                        </p>
                                        <p class="text" v-if="
                                            hearthIntern.regime_copart == 1
                                        ">
                                            {{ hearthIntern.regime_copart }}
                                            {{ $t('pages.hearth.typeadm') }}
                                            <span>Comparticipadas pelo(a)
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                        <p class="text" v-else>
                                            {{ hearthIntern.regime_copart }}
                                            {{ $t('pages.hearth.vacancy') }}
                                            <span>{{ $t('pages.hearth.coopart') }}
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title"></p>
                                        <p class="text" v-if="
                                            hearthIntern.regime_no_copart ==
                                            1
                                        ">
                                            {{ hearthIntern.regime_no_copart }}
                                            {{ $t('pages.hearth.vacancy') }}
                                            <span> {{ $t('pages.hearth.nopart') }}
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                        <p class="text" v-else>
                                            {{ hearthIntern.regime_no_copart }}
                                            vagas
                                            <span>{{ $t('pages.hearth.nopart') }}
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="content-element-showless" v-if="!showLess">
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">
                                            {{ $t('pages.hearth.propertentity') }}
                                        </p>
                                        <p class="text">
                                            {{ hearthIntern.partner }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.direction') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.direction }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.address') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.address }},
                                            {{ hearthIntern.number }} <br />
                                            {{ hearthIntern.postal_code }}
                                            {{ hearthIntern.distrito }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.phonecontact') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.telephone }}
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.mail') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.email }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.hourvisit') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.visiting_hours }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.maximumcapacity') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.maximum_capacity }}
                                            {{ $t('pages.hearth.users') }}
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title">
                                            {{ $t('pages.hearth.socialsecurity') }}
                                        </p>
                                        <p class="text">
                                            {{ hearthIntern.social_insurance }}
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title">{{ $t('pages.hearth.datefundation') }}</p>
                                        <p class="text">
                                            {{ hearthIntern.founded }}
                                        </p>
                                    </div>
                                </div>
                                <div class="content-element">
                                    <div class="content-element-text">
                                        <p class="title">
                                            {{ $t('pages.hearth.typeadm') }}
                                        </p>
                                        <p class="text" v-if="
                                            hearthIntern.regime_copart == 1
                                        ">
                                            {{ hearthIntern.regime_copart }}
                                            vaga
                                            <span>{{ $t('pages.hearth.coopart') }}
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                        <p class="text" v-else>
                                            {{ hearthIntern.regime_copart }}
                                            {{ $t('pages.hearth.vacancy') }}
                                            <span>{{ $t('pages.hearth.coopart') }}
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                    </div>
                                    <div class="content-element-text">
                                        <p class="title"></p>
                                        <p class="text" v-if="
                                            hearthIntern.regime_no_copart ==
                                            1
                                        ">
                                            {{ hearthIntern.regime_no_copart }}
                                            vaga
                                            <span>{{ $t('pages.hearth.nopart') }}
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                        <p class="text" v-else>
                                            {{ hearthIntern.regime_no_copart }}
                                            {{ $t('pages.hearth.vacancy') }}
                                            <span>{{ $t('pages.hearth.nopart') }}
                                                {{
                                                    hearthIntern.copart_type
                                                }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div class="btn-general-information d-lg-none">
                                    <button @click="showLess = true">
                                        <p>{{ $t('generic.seeLess') }}</p>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 p-0">
                        <div class="content-banner-ads">
                            <div v-if="publicities.image_halfpage == null">
                                <img class="img-fluid" src="@/assets/img/hearth/banner-ads-2.png" alt="banner ads"
                                    title="banner ads" />
                            </div>
                            <a :href="publicities.image_halfpage_url" target="_blank" rel="noopener" v-else>
                                <img class="img-fluid" :src="publicities.image_halfpage.path" alt="banner ads"
                                    title="banner ads" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-information container">
                <div class="content-information-element" v-for="(c, index, k) in hearthIntern.tags" :key="k">
                    <div class="content-information-element-header">
                        <h2>{{ index }}</h2>
                    </div>
                    <div class="content-information-element-body">
                        <div class="content-element" v-for="(tag, i) in c" :key="i">
                            <svg xmlns="http://www.w3.org/2000/svg" width="40.045" height="39.925"
                                viewBox="0 0 40.045 39.925">
                                <path
                                    d="M7.7,17.057a1.547,1.547,0,0,1,2.155,0,1.536,1.536,0,0,1,.478,2.094,1.547,1.547,0,0,1-2.154,0A1.535,1.535,0,0,1,7.7,17.057m12.848-1.212c1.215-1.364,2.576-2.66,3.832-3.97a.41.41,0,0,1,.572-.019l.432.4a.407.407,0,0,1,.027.573c-1.5,1.66-2.978,3.534-4.325,5.226-.184-.846-.371-1.589-.539-2.206m3.827,4.6A32.072,32.072,0,0,1,30.4,16.957a.411.411,0,0,1,.545.2l.231.5A.406.406,0,0,1,31,18.19a31.856,31.856,0,0,0-4.222,2.71,9.374,9.374,0,0,0-2.4-.45m-6.226,9.535a25.946,25.946,0,0,0-2.21-6.346.4.4,0,0,0-.315-.232c-2.682-.364-5.056-.659-7.7-.832a.408.408,0,0,1-.382-.424l.028-.661A.41.41,0,0,1,8,21.1c1.68.06,3.306.062,4.946.167.046,0,3.5.256,4.7,1.653.271.585.535,1.2.784,1.83.369.933-.136,4.143-.275,5.235m-3.8-9.369c-1.249-2.16-2.34-3.722-2.79-4.344a.405.405,0,0,1,.06-.543l.51-.451a.41.41,0,0,1,.572.029,28.1,28.1,0,0,1,3.821,5.405q.184.335.368.687a10.606,10.606,0,0,0-2.541-.782M21.269,8.571a1.538,1.538,0,0,1,1.116,1.837A1.541,1.541,0,0,1,20.837,11.9a1.538,1.538,0,0,1-1.116-1.837,1.541,1.541,0,0,1,1.548-1.493M32.893,7.13A18.174,18.174,0,1,0,7.152,32.794a6.12,6.12,0,0,0,1.059.976c2.492,1.52,7.458.675,8.688.321.6-.172,1.149-.407,1.3-1.009a35,35,0,0,0,.008-15.975,42.806,42.806,0,0,0-2.453-6.974.406.406,0,0,1,.171-.527l.58-.324a.41.41,0,0,1,.551.147,27.381,27.381,0,0,1,2.265,4.981,40.955,40.955,0,0,1,1.333,5.4h.008c.141.869.253,1.772.323,2.7a.409.409,0,0,0,.692.263c.493-.474.974-.912,1.453-1.32a5.668,5.668,0,0,1,3.526.284l.044.019q.531.19,1.059.4c.235.1.374.168.376.168l.008-.016c1.4.562,2.777,1.187,4.151,1.756a.407.407,0,0,1,.224.526l-.185.469a.41.41,0,0,1-.521.234c-2.374-.868-4.964-1.6-7.311-2.319a.4.4,0,0,0-.389.083,25.04,25.04,0,0,0-2.831,2.933.39.39,0,0,0-.1.243c-.008.166-.016.327-.025.486a31.553,31.553,0,0,0,.8,6.37,1.4,1.4,0,0,0,1.3,1.008c1.409.128,6.314,1.109,8.568-.321a6.62,6.62,0,0,0,1.059-.976,18.109,18.109,0,0,0,0-25.664M20.022,0A19.992,19.992,0,1,1,5.864,5.847,19.99,19.99,0,0,1,20.022,0M34.275,20.688a1.728,1.728,0,0,0-3.317.585,1.728,1.728,0,0,0,3.317-.585"
                                    fill="var( --green-medium)" />
                            </svg>
                            <p>{{ tag }}</p>
                        </div>
                    </div>
                    <hr />
                </div>
            </div>
            <div class="content-customer-review container" id="rate">
                <div class="content-customer-review-header">
                    <h2>{{ $t('generic.clientavaliation') }}</h2>
                </div>
                <div class="content-customer-review-classification">
                    <div class="content-elements rate">
                        <div class="content-classification">
                            <p>{{ hearthIntern.rate }}</p>
                            <svg xmlns="http://www.w3.org/2000/svg" width="34.657" height="33.171"
                                viewBox="0 0 34.657 33.171">
                                <path
                                    d="M35.969,1.141l-4.23,8.577L22.275,11.1a2.074,2.074,0,0,0-1.147,3.537l6.847,6.672-1.619,9.425a2.072,2.072,0,0,0,3.006,2.183l8.467-4.45,8.467,4.45A2.073,2.073,0,0,0,49.3,30.733l-1.62-9.425,6.847-6.672A2.074,2.074,0,0,0,53.382,11.1l-9.464-1.38-4.23-8.577a2.075,2.075,0,0,0-3.718,0Z"
                                    transform="translate(-20.5 0.013)" fill="#fff" />
                            </svg>
                        </div>
                        <template v-if="totalcomment > 1">
                            <div class="content-quantity-coments">
                                <p>{{ totalcomment }} comentários</p>
                            </div>
                        </template>
                        <template v-if="totalcomment < 1">
                            <div class="content-quantity-coments">
                                <p>{{ totalcomment }} comentários</p>
                            </div>
                        </template>
                    </div>
                    <div class="content-elements" v-if="userIsLogged">
                        <button class="btn-opinion" @click="$bvModal.show('modal-opinion')">
                            {{ $t('pages.hearth.opinion') }}
                        </button>
                    </div>
                    <div class="content-elements" v-else>
                        <button class="btn-opinion" @click="alertLogin()">
                            {{ $t('pages.hearth.opinion') }}
                        </button>
                    </div>
                </div>
                <div class="content-customer-review-body" v-if="showLess">
                    <div class="content-card-coment" v-for="(n, index) in comments.slice(0, 3)" :key="index">
                        <div class="content-card-coment-element-one">
                            <div class="content-card-coment-element-avaliation">
                                <p>{{ n.rate }}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16.943" height="16.216"
                                    viewBox="0 0 16.943 16.216">
                                    <path
                                        d="M28.062.551,25.994,4.744l-4.627.675a1.014,1.014,0,0,0-.561,1.729l3.347,3.262-.792,4.608a1.013,1.013,0,0,0,1.469,1.067l4.139-2.176,4.139,2.176a1.014,1.014,0,0,0,1.469-1.067l-.792-4.608,3.347-3.262a1.014,1.014,0,0,0-.561-1.729l-4.627-.675L29.88.551a1.014,1.014,0,0,0-1.818,0Z"
                                        transform="translate(-20.5 0.013)" fill="#fff" />
                                </svg>
                            </div>
                            <div class="content-card-coment-element-name">
                                <p>{{ n.user }}</p>
                                <p>{{ n.created_at }}</p>
                            </div>
                        </div>
                        <div class="content-card-coment-element-two">
                            <div class="content-card-coment-element-text">
                                <p>{{ n.message }}</p>
                            </div>
                        </div>
                    </div>
                    <button class="btn-view-more" v-if="comments.length > 3" @click="showLess = false">
                        {{ $t('pages.hearth.more') }}
                    </button>
                </div>
                <div class="content-customer-review-body" v-else>
                    <div class="content-card-coment" v-for="(n, index) in comments" :key="index">
                        <div class="content-card-coment-element-one">
                            <div class="content-card-coment-element-avaliation">
                                <p>{{ n.rate }}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16.943" height="16.216"
                                    viewBox="0 0 16.943 16.216">
                                    <path
                                        d="M28.062.551,25.994,4.744l-4.627.675a1.014,1.014,0,0,0-.561,1.729l3.347,3.262-.792,4.608a1.013,1.013,0,0,0,1.469,1.067l4.139-2.176,4.139,2.176a1.014,1.014,0,0,0,1.469-1.067l-.792-4.608,3.347-3.262a1.014,1.014,0,0,0-.561-1.729l-4.627-.675L29.88.551a1.014,1.014,0,0,0-1.818,0Z"
                                        transform="translate(-20.5 0.013)" fill="#fff" />
                                </svg>
                            </div>
                            <div class="content-card-coment-element-name">
                                <p>{{ n.user }}</p>
                                <p>{{ n.created_at }}</p>
                            </div>
                        </div>
                        <div class="content-card-coment-element-two">
                            <div class="content-card-coment-element-text">
                                <p>{{ n.message }}</p>
                            </div>
                        </div>
                    </div>
                    <button class="btn-view-more" @click="showLess = true">
                        {{ $t('generic.seeLess') }}
                    </button>
                </div>
            </div>
            <FormOrder :hearthIntern="hearthIntern" :slug="slug" />
            <Suggestion :hearthSuggestion="hearthSuggestion" v-if="hearthSuggestion" />

            <template v-if="this.hearthIntern.social_media">
                <socialMedia :social="socialNetworks" />
            </template>

            <div class="content-brand container" style="margin-top: 80px">
                <GoToBackButton />
            </div>
            <modal-opinion />
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import ModalOpinion from "@/components/modals/ModalOpinion";
import { mapGetters } from "vuex";
import Vue from "vue";
import TextLineClamp from "@/components/textLineClamp/TextLineClamp";
import SocialSharing from "@/components/socialSharing/SocialSharing.vue";
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import BtnFavorite from "@/components/btnFavorite/Index";
import socialMedia from "@/components/socialSharing/SocialMedia.vue";

import FormOrder from "@/views/Hearth/components/FormOrder.vue";
import Suggestion from "@/views/Hearth/components/Suggestion.vue";

export default {
    data() {
        return {
            showLess: true,
            slug: this.$route.params.slug,
            partner_id: this.$route.params.partner_id,
            swiperOptionTop: {
                // loop: true,
                loopedSlides: 6, // looped slides should be the same
                spaceBetween: 30,
                speed: 800,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            swiperOptionThumbs: {
                // loop: true,
                loopedSlides: 3, // looped slides should be the same
                spaceBetween: 15,
                centeredSlides: true,
                slidesPerView: "auto",
                touchRatio: 0.2,
                slideToClickedSlide: true,
                speed: 800,
                breakpoints: {
                    991: {
                        loopedSlides: 6,
                        slidesPerView: 6,
                        spaceBetween: 30,
                    },
                },
            },
        };
    },
    props: ["social"],
    components: {
        Swiper,
        SwiperSlide,
        FormOrder,
        ModalOpinion,
        TextLineClamp,
        SocialSharing,
        GoToBackButton,
        Suggestion,
        BtnFavorite,
        socialMedia,
    },
    computed: {
        ...mapGetters("User", ["userIsLogged"]),
        ...mapGetters({
            user: "User/user",
            userFavorite: "User/userFavorite",
            publicities: "Publicity/publicities",
            hearthIntern: "Hearth/hearthIntern",
            hearthSuggestion: "Hearth/hearthSuggestion",
            comments: "Hearth/comments",
            totalcomment: "Hearth/totalcomment",
        }),
        socialNetworks() {
            if (this.hearthIntern.social_media.length > 0) {
                return this.hearthIntern.social_media.map((item) => {
                    return {
                        social_network: item.rede_social,
                        url: item.url,
                    };
                });
            } else {
                return [];
            }
        },
    },
    methods: {
        alertLogin() {
            Vue.fire({
                type: "info",
                title: "Atenção",
                text: "É necessário fazer login para comentar.",
                timer: 3000,
                showConfirmButton: true,
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            const swiperTop = this.$refs.swiperTop.$swiper;
            const swiperThumbs = this.$refs.swiperThumbs.$swiper;
            swiperTop.controller.control = swiperThumbs;
            swiperThumbs.controller.control = swiperTop;
        });

        this.$store.dispatch("Hearth/getHearthIntern", { slug: this.slug });
        this.$store.dispatch("Hearth/getHearthSuggestion", { slug: this.slug });
        this.$store.dispatch("Publicity/getPublicities", this.$route.name);
    },
};
</script>

<style lang="scss">
.content-hearth-intern {
    margin-top: 170px;
    padding: 50px 0px;

    @media (max-width: 991px) {
        margin-top: 62px;
    }

    @media (max-width: 767px) {
        padding: 30px 0px;
    }

    &-itens {
        @media screen and (max-width: 991px) {
            max-width: 100% !important;
            padding: 0 !important;
        }

        .content-brand {
            @media screen and (max-width: 991px) {
                width: 100%;
                display: flex;
                justify-content: space-between;
            }
        }

        .content-gallery {
            @media screen and (max-width: 991px) {
                position: relative;
                padding: 0 !important;
            }

            &-banner {
                position: relative;

                .gallery-top {
                    &-image {
                        width: 100%;
                        height: 450px;
                        background-repeat: no-repeat !important;
                        background-position: center !important;
                        background-size: cover !important;
                        border-radius: 10px 10px 0px 0px;

                        @media (max-width: 991px) {
                            max-width: 100% !important;
                            height: 450px;
                            border-radius: 0;
                        }
                    }
                }

                .gallery-thumbs {
                    position: absolute;
                    width: 100%;
                    margin-top: -70px;
                    padding: 10px 0px;
                    min-height: 170px;

                    @media (max-width: 991px) {
                        margin-top: -50px;
                        min-height: initial;
                    }

                    .swiper-wrapper {
                        height: 100%;
                        display: flex !important;
                        align-items: center !important;
                    }

                    .swiper-slide {
                        height: 100%;
                        display: flex !important;
                        align-items: center;
                        justify-content: center;
                        width: 160px !important;
                        margin-right: 10px !important;
                        cursor: pointer;

                        @media (max-width: 991px) {
                            display: flex !important;
                            align-items: center;
                            justify-content: center;
                            height: 90px !important;
                            width: 90px !important;
                        }

                        .gallery-thumbs-image {
                            width: 114px;
                            height: 114px;
                            background-repeat: no-repeat !important;
                            background-position: center !important;
                            background-size: cover !important;
                            border-radius: 5px;
                            transition: 500ms;

                            @media (max-width: 991px) {
                                width: 70px;
                                height: 70px;
                            }

                            img {
                                width: 70px;
                                height: 70px;
                                border-radius: 5px;
                            }
                        }
                    }

                    .swiper-slide-active {
                        .gallery-thumbs-image {
                            width: 144px;
                            height: 144px;
                            border-color: var(--white);
                            border: 5px solid var(--white);
                            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

                            // transform: scale(1.1);
                            @media (max-width: 991px) {
                                width: 90px;
                                height: 90px;
                            }
                        }
                    }

                    &-image {
                        position: relative;
                        display: inline-block;
                    }
                }
            }

            &-description {
                background: #f2f2f2;
                padding: 120px 40px 30px 40px;
                border-radius: 0px 0px 10px 10px;

                @media (max-width: 991px) {
                    padding: 100px 20px 30px 20px;
                }

                &-text {
                    text-align: left;

                    .title {
                        font-size: 34px;
                        font-family: "Font Bold";
                        color: var(--green-dark);
                        margin-bottom: 20px;

                        @media (max-width: 991px) {
                            font-size: 24px;
                        }
                    }

                    .location {
                        display: flex;
                        align-items: center;

                        svg {
                            width: 22px;
                            height: 29px;

                            @media screen and (max-width: 991px) {
                                width: 16px;
                                height: 22px;
                            }
                        }

                        p {
                            font-size: 24px;
                            font-family: "Font Regular";
                            color: var(--green-dark);
                            margin-left: 10px;
                            margin-bottom: 0;

                            @media (max-width: 991px) {
                                font-size: 18px;
                            }
                        }
                    }
                }

                &-btns {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 30px;

                    @media (max-width: 991px) {
                        flex-direction: column;
                        align-items: flex-start;
                    }

                    .content-category {
                        display: flex;
                        align-items: center;

                        @media (max-width: 991px) {
                            align-items: flex-start;
                            text-align: left;
                            margin-bottom: 20px;

                            svg {
                                margin-top: 3px;
                                max-width: 26px;
                                height: 23px;

                                @media screen and (max-width: 991px) {
                                    max-width: 20px;
                                    height: 19px;
                                }
                            }
                        }

                        p {
                            font-size: 24px;
                            font-family: "Font Bold";
                            color: var(--green-medium);
                            margin-left: 10px;
                            margin-bottom: 0;

                            @media (max-width: 991px) {
                                font-size: 18px;
                            }
                        }
                    }

                    .content-btns {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;

                        @media (max-width: 991px) {
                            width: 100%;
                            justify-content: initial;
                            gap: 15px;
                        }

                        @media (max-width: 400px) {
                            flex-direction: column;
                            align-items: flex-start;
                        }

                        &-classification {
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                            width: 230px;
                            height: 60px;
                            background: #e69c5a;
                            border: 1px solid #e69c5a;
                            border-radius: 8px;
                            padding: 10px 20px;
                            margin-right: 30px;
                            transition: 500ms;

                            @media (max-width: 991px) {
                                position: absolute;
                                top: 40px;
                                right: 10%;
                                z-index: 1;
                                width: 231px;
                                align-content: center;
                                justify-content: space-around;
                                height: 60px;
                                margin-right: 0;
                            }

                            &:hover,
                            &:focus {
                                opacity: 0.8;
                            }

                            &-note {
                                display: flex;
                                align-items: center;
                                padding-right: 20px;
                                border-right: 1px solid var(--white);

                                p {
                                    font-size: 33px;
                                    font-family: "Font Bold";
                                    color: var(--white);
                                    margin-right: 10px;
                                    margin-bottom: 0;
                                    line-height: 1;

                                    @media (max-width: 991px) {
                                        font-size: 33px;
                                    }
                                }

                                svg {
                                    @media (max-width: 991px) {
                                        max-width: 35px;
                                    }
                                }
                            }

                            &-coments {
                                display: flex;
                                align-items: center;

                                p {
                                    font-size: 23px;
                                    font-family: "Font Regular";
                                    color: var(--white);
                                    margin-right: 10px;
                                    margin-bottom: 0;

                                    @media (max-width: 991px) {
                                        font-size: 33px;
                                    }
                                }

                                svg {
                                    @media (max-width: 991px) {
                                        max-width: 35px;
                                    }
                                }
                            }
                        }

                        .btn-request-contact {
                            width: 258px;
                            height: 60px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            justify-content: center;
                            background: var(--green-medium);
                            border: 1px solid var(--green-medium);
                            border-radius: 10px;
                            box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
                            font-size: 22px;
                            font-family: "Font Regular";
                            color: var(--white);
                            transition: 500ms;

                            @media (max-width: 991px) {
                                width: 100%;
                                max-width: 200px;
                                height: 45px;
                                font-size: 18px;
                            }

                            &:hover,
                            &:focus {
                                cursor: pointer;
                                background: var(--white);
                                color: var(--green-medium);
                            }
                        }
                    }
                }
            }
        }

        .content-hearth-img-info-btn {
            margin: 20px 0px;
            padding: 0 !important;
            width: 100%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            gap: 20px;

            @media (max-width: 991px) {
                width: auto;
                margin: 0;
            }
        }

        .content-description-text {
            margin-top: 75px;
            padding-bottom: 35px;
            border-bottom: 1px solid #e7e7e7;
            text-align: left;

            @media (max-width: 991px) {
                margin-top: 50px;
                padding-bottom: 30px;
                border-bottom: none;
            }

            p {
                font-size: 24px;
                font-family: "Font Regular";
                color: #555555;
                margin-bottom: 0;

                @media (max-width: 991px) {
                    font-size: 18px;
                }
            }

            .btn-read-more {
                width: 112px;
                height: 45px;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--white);
                border: 1px solid var(--green-medium);
                border-radius: 10px;
                box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
                font-size: 18px;
                font-family: "Font Regular";
                color: var(--green-medium);
                margin-top: 30px;
                transition: 500ms;

                &:hover,
                &:focus {
                    cursor: pointer;
                    background: var(--green-medium);
                    color: var(--white);
                }
            }
        }

        .content-information-general {
            padding: 30px 15px;

            /* border-top: 1px solid #e7e7e7; */
            @media (max-width: 991px) {
                padding: 30px 15px;
            }

            &-text {
                text-align: left;
                padding: 20px 0px;

                &-header {
                    h2 {
                        font-size: 28px;
                        font-family: "Font Bold";
                        color: var(--green-medium);
                        margin-bottom: 0;
                    }
                }

                .desktop {
                    @media screen and (max-width: 991px) {
                        display: none !important;
                    }
                }

                .content-element {
                    display: flex;
                    padding: 25px 0px;
                    max-width: 700px;
                    align-items: flex-end;

                    &:last-child {
                        padding-bottom: 0;
                    }

                    @media (max-width: 991px) {
                        padding: 15px 0px;
                        flex-direction: column;
                        gap: 30px;
                    }

                    &-text {
                        max-width: 700px;
                        margin-right: 60px;

                        @media (max-width: 991px) {
                            width: 100%;
                            margin-right: 0;
                        }

                        &:last-child {
                            margin-right: 0;
                        }

                        .title {
                            font-size: 18px;
                            font-family: "Font Regular";
                            color: var(--green-medium);
                            word-break: break-word;
                            margin-bottom: 12px;

                            @media (max-width: 991px) {
                                margin-bottom: 0;
                            }
                        }

                        .text {
                            font-size: 22px;
                            font-family: "Font Regular";
                            color: var(--green-dark);
                            word-break: break-word;
                            margin-bottom: 0;

                            span {
                                display: block;
                                font-size: 18px;
                                font-family: "Font Regular";
                                color: #878787;

                                @media (max-width: 767px) {
                                    font-size: 12px;
                                }
                            }
                        }
                    }
                }
            }
        }

        .content-banner-ads {
            padding: 30px;
            background: #f2f2f2;
            border-radius: 10px;

            @media (max-width: 991px) {
                padding: 20px;
                margin-top: 30px;
            }
        }

        .content-information {
            padding: 0 !important;

            &-element {
                /* padding: 40px 0px 40px 0px; */
                /* border-bottom: 1px solid #e7e7e7; */
                text-align: left;

                hr {
                    margin-block: 40px;
                }

                @media (max-width: 991px) {
                    padding: 30px 0px 20px 0px;
                }

                &:last-child {
                    border-bottom: none;
                }

                &-header {
                    margin-bottom: 20px;

                    h2 {
                        font-size: 28px;
                        font-family: "Font Bold";
                        color: var(--green-medium);
                        line-height: 1;
                        margin-bottom: 0;

                        @media (max-width: 991px) {
                            font-size: 20px;
                        }
                    }
                }

                &-body {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;

                    @media (max-width: 576px) {
                        flex-direction: column;
                    }

                    .content-element {
                        display: flex;
                        align-items: center;
                        width: calc(25% - 30px);
                        padding: 20px 0px;
                        margin-right: 30px;

                        @media (min-width: 577px) and (max-width: 991px) {
                            width: calc(33.3% - 30px);
                        }

                        @media (max-width: 576px) {
                            width: 100%;
                            padding: 10px 0px;
                            margin-right: 0;

                            svg {
                                max-width: 30px;
                            }
                        }

                        &:last-child {
                            margin-right: 0;
                        }

                        p {
                            font-size: 20px;
                            font-family: "Font Regular";
                            color: var(--green-dark);
                            margin-left: 15px;
                            width: calc(100% - 55px);
                            margin-bottom: 0;

                            @media (max-width: 991px) {
                                font-size: 18px;
                            }

                            @media (max-width: 576px) {
                                width: calc(100% - 45px);
                            }
                        }
                    }
                }
            }
        }

        .content-customer-review {
            padding: 100px 0px;

            @media (max-width: 991px) {
                padding: 30px 15px;
            }

            &-header {
                text-align: left;
                margin-bottom: 40px;

                @media (max-width: 991px) {
                    margin-bottom: 30px;
                }

                h2 {
                    font-size: 28px;
                    font-family: "Font Bold";
                    color: var(--green-medium);
                    margin-bottom: 0px;

                    @media (max-width: 991px) {
                        font-size: 20px;
                    }
                }
            }

            &-classification {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 50px;

                @media (max-width: 991px) {
                    flex-direction: row;
                    align-items: flex-start;
                }

                .rate {
                    gap: 25px;

                    @media screen and (max-width: 991px) {
                        flex-direction: column !important;
                    }
                }

                .content-elements {
                    display: flex;
                    align-items: center;
                    flex-direction: row;

                    @media (max-width: 991px) {
                        align-items: flex-start;
                    }

                    .content-classification {
                        width: 140px;
                        height: 65px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #e69c5a;
                        border: 1px solid #e69c5a;
                        border-radius: 8px;
                        margin-right: 30px;
                        transition: 500ms;

                        @media (max-width: 1199px) {
                            width: 100px;
                            height: 50px;
                            margin-right: 0px;
                            align-content: flex-start;
                        }

                        &:hover,
                        &:focus {
                            cursor: pointer;
                            opacity: 0.8;
                        }

                        p {
                            font-size: 33px;
                            font-family: "Font Bold";
                            color: var(--white);
                            margin-right: 15px;
                            margin-bottom: 0;

                            @media (max-width: 1199px) {
                                font-size: 20px;
                            }
                        }

                        svg {
                            @media (max-width: 1199px) {
                                max-width: 25px;
                            }

                            @media (max-width: 991px) {
                                max-width: 20px;
                            }
                        }
                    }

                    .content-quantity-coments {
                        p {
                            font-size: 26px;
                            font-family: "Font Regular";
                            color: var(--green-dark);
                            margin-bottom: 0;

                            @media (max-width: 1199px) {
                                font-size: 18px;
                            }

                            @media (max-width: 991px) {
                                font-size: 18px;
                            }
                        }
                    }

                    .content-elements-score {
                        display: flex;
                        align-items: center;
                        margin-right: 40px;

                        @media (max-width: 1199px) {
                            margin-right: 20px;
                        }

                        @media (max-width: 991px) {
                            margin-bottom: 10px;
                        }

                        &:last-child {
                            margin-right: 0;
                        }

                        &-star {
                            width: 67px;
                            height: 36px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: var(--white);
                            border: 1px solid #e69c5a;
                            border-radius: 8px;
                            margin-right: 15px;

                            @media (max-width: 1199px) {
                                width: 60px;
                            }

                            p {
                                font-size: 22px;
                                font-family: "Font Bold";
                                color: #e69c5a;
                                margin-right: 10px;
                                margin-bottom: 0;

                                @media (max-width: 1199px) {
                                    font-size: 18px;
                                }
                            }
                        }

                        &-quantity {
                            p {
                                font-size: 26px;
                                font-family: "Font Regular";
                                color: var(--green-dark);
                                margin-bottom: 0;

                                @media (max-width: 1199px) {
                                    font-size: 18px;
                                }
                            }
                        }
                    }

                    button {
                        all: unset;
                        cursor: pointer;
                        width: 203px;
                        height: 45px;
                        border: 1px solid var(--green-medium);
                        background: var(--green-medium);
                        box-shadow: 5px 5px 5px #00000016;
                        color: var(--white);
                        font-size: 18px;
                        font-family: "Font Regular", sans-serif;
                        border-radius: 8px;
                        transition: 500ms;

                        &:hover,
                        &:focus {
                            background-color: var(--white);
                            color: var(--green-medium);
                            opacity: 0.8;
                        }
                    }
                }
            }

            &-body {
                .content-card-coment {
                    padding: 30px 20px;
                    background: var(--white);
                    border: 1px solid #e7e7e7;
                    border-radius: 10px;
                    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 50px;

                    @media (max-width: 991px) {
                        flex-direction: column;
                        margin-bottom: 30px;
                    }

                    &-element {
                        &-one {
                            width: 160px;
                            margin-right: 80px;

                            @media (max-width: 991px) {
                                width: 100%;
                                margin-right: 0;
                                margin-bottom: 30px;
                            }
                        }

                        &-two {
                            width: calc(100% - 240px);

                            @media (max-width: 991px) {
                                width: 100%;
                            }
                        }

                        &-avaliation {
                            width: 67px;
                            height: 36px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            background: #e69c5a;
                            border-radius: 8px;
                            margin-bottom: 20px;

                            @media (max-width: 991px) {
                                margin: 0 auto 20px auto;
                            }

                            p {
                                font-size: 22px;
                                font-family: "Font Bold";
                                color: var(--white);
                                margin-right: 10px;
                                margin-bottom: 0;

                                @media (max-width: 991px) {
                                    font-size: 18px;
                                }
                            }
                        }

                        &-name {
                            text-align: left;

                            @media (max-width: 991px) {
                                text-align: center;
                            }

                            p {
                                font-size: 22px;
                                font-family: "Font Regular";
                                color: #b7b8b8;
                                margin-bottom: 0px;

                                @media (max-width: 1199px) {
                                    font-size: 18px;
                                }
                            }
                        }

                        &-text {
                            text-align: left;

                            h3 {
                                font-size: 22px;
                                font-family: "Font Bold";
                                color: var(--green-dark);
                                margin-bottom: 12px;

                                @media (max-width: 1199px) {
                                    font-size: 18px;
                                }
                            }

                            p {
                                font-size: 22px;
                                font-family: "Font Regular";
                                color: #555555;
                                display: -webkit-box;
                                -webkit-line-clamp: 4;
                                -webkit-box-orient: vertical;
                                overflow: hidden;
                                margin-bottom: 0;

                                @media (max-width: 1199px) {
                                    font-size: 18px;
                                }
                            }
                        }
                    }
                }

                .btn-view-more {
                    width: 133px;
                    height: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: var(--green-medium);
                    border: 1px solid var(--green-medium);
                    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
                    border-radius: 10px;
                    font-size: 18px;
                    font-family: "Font Regular";
                    color: var(--white);
                    margin: 0 auto;
                    transition: 500ms;

                    &:hover,
                    &:focus {
                        cursor: pointer;
                        background: var(--white);
                        color: var(--green-medium);
                    }
                }
            }
        }
    }
}

.btn-general-information {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px 0;

    button {
        all: unset;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 112px;
        height: 45px;
        background: var(--white);
        border: 1px solid var(--green-medium);
        border-radius: 10px;

        p {
            margin-bottom: 0px;
            font-family: "Font Regular", sans-serif;
            font-size: 18px;
            color: var(--green-medium);
        }

        &:target,
        &:active {
            .desktop {
                display: flex !important;
            }
        }
    }
}
</style>
